import { render, staticRenderFns } from "./Legislation.vue?vue&type=template&id=851c4648&scoped=true&"
import script from "./Legislation.vue?vue&type=script&lang=js&"
export * from "./Legislation.vue?vue&type=script&lang=js&"
import style0 from "./Legislation.vue?vue&type=style&index=0&id=851c4648&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851c4648",
  null
  
)

export default component.exports